import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=65646c80&scoped=true&"
import script from "./Type.vue?vue&type=script&lang=ts&"
export * from "./Type.vue?vue&type=script&lang=ts&"
import style0 from "./Type.vue?vue&type=style&index=0&id=65646c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65646c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
